import { computed } from 'vue'
import OrionError from '../../../error/OrionError'

import camelize from '../../_antd_util/camelize'
import { filterEmpty } from '../../_antd_util'

function genColumns(children) {
  const tableColumns = children?.map((c) => {
    const props = { ...(c.props || {}) }
    for (const [k, v] of Object.entries(props)) {
      delete props[k]
      props[camelize(k)] = v
    }

    if (c.type.name === 'OEdittableColumnIndex') {
      return {
        type: c.type.name,
      }
    } else if (c.type.name === 'OEdittableColumnString') {
      return {
        type: c.type.name,
        head: props?.head,
        headAlign: props?.headAlign,
        bodyAlign: props?.bodyAlign,
        name: props?.name,
        width: props?.width,
        fixed: props?.fixed,

        editable: props?.editable,
        cellEditable: props?.cellEditable,
        maxlength: props?.maxlength,
        placeholder: props?.placeholder,

        children: c.children,
      }
    } else if (c.type.name === 'OEdittableColumnLov') {
      return {
        type: c.type.name,
        head: props?.head,
        headAlign: props?.headAlign,
        bodyAlign: props?.bodyAlign,
        name: props?.name,
        width: props?.width,
        fixed: props?.fixed,

        editable: props?.editable,
        cellEditable: props?.cellEditable,
        maxlength: props?.maxlength,
        placeholder: props?.placeholder,
        fillMapping: props?.fillMapping,

        children: c.children,
      }
    } else if (c.type.name === 'OEdittableColumnCheckbox') {
      return {
        type: c.type.name,
        head: props?.head,
        headAlign: props?.headAlign,
        bodyAlign: props?.bodyAlign,
        name: props?.name,
        width: props?.width,
        fixed: props?.fixed,

        editable: props?.editable,
        cellEditable: props?.cellEditable,

        children: c.children,
      }
    } else if (c.type.name === 'OEdittableColumnNumber') {
      return {
        type: c.type.name,
        head: props?.head,
        headAlign: props?.headAlign,
        bodyAlign: props?.bodyAlign,
        name: props?.name,
        width: props?.width,
        fixed: props?.fixed,

        thousandsSeparator: props?.thousandsSeparator,
        precision: Number(props?.precision),
        percentage: props?.percentage,

        editable: props?.editable,
        cellEditable: props?.cellEditable,
        placeholder: props?.placeholder,
        min: props?.min,
        max: props?.max,
        step: props?.step,
        stepStrictly: props?.stepStrictly,
        controls: props?.controls,
        controlsPosition: props?.controlsPosition,

        children: c.children,
      }
    } else if (c.type.name === 'OEdittableColumnDate') {
      return {
        type: c.type.name,
        head: props?.head,
        headAlign: props?.headAlign,
        bodyAlign: props?.bodyAlign,
        name: props?.name,
        width: props?.width,
        fixed: props?.fixed,

        editable: props?.editable,
        cellEditable: props?.cellEditable,
        maxlength: props?.maxlength,
        placeholder: props?.placeholder,
        clearable: props?.clearable,
        format: props?.format,
        sourceFormat: props?.sourceFormat,

        children: c.children,
      }
    } else if (c.type.name === 'OEdittableColumnSingleselect') {
      return {
        type: c.type.name,
        head: props?.head,
        headAlign: props?.headAlign,
        bodyAlign: props?.bodyAlign,
        name: props?.name,
        width: props?.width,
        fixed: props?.fixed,

        code: props?.code,

        editable: props?.editable,
        cellEditable: props?.cellEditable,
        placeholder: props?.placeholder,
        clearable: props?.clearable,
        filterable: props?.filterable,

        children: c.children,
      }
    } else if (c.type.name === 'OEdittableColumnMultiselect') {
      return {
        type: c.type.name,
        head: props?.head,
        headAlign: props?.headAlign,
        bodyAlign: props?.bodyAlign,
        name: props?.name,
        width: props?.width,
        fixed: props?.fixed,

        code: props?.code,

        editable: props?.editable,
        cellEditable: props?.cellEditable,
        placeholder: props?.placeholder,
        collapseTags: props?.collapseTags,
        collapseTagsTooltip: props?.collapseTagsTooltip,

        children: c.children,
      }
    } else if (c.type.name === 'OEdittableColumnButtongroup') {
      return {
        type: c.type.name,

        head: props?.head,
        headAlign: props?.headAlign,
        bodyAlign: props?.bodyAlign,
        name: props?.name,
        width: props?.width,
        fixed: props?.fixed,

        children: c.children,
      }
    } else if (c.type.name === 'OEdittableColumngroup') {
      return {
        type: c.type.name,

        head: props?.head,
        headAlign: props?.headAlign,

        children: genColumns(filterEmpty(c.children?.default?.())),
      }
    } else if (c.type.name === 'OEdittableColumnDiy') {
      return {
        type: c.type.name,

        head: props?.head,
        headAlign: props?.headAlign,
        name: props?.name,
        width: props?.width,
        fixed: props?.fixed,

        children: c.children,
      }
    } else {
      throw new OrionError(`OEdittable不能正确解析'${c.type.name}'子组件。`)
    }
  })

  return tableColumns
}

export default function useColumns(slots) {
  const columns = computed(() => {
    const children = slots.default?.()

    const non_empty_children = filterEmpty(children)

    const tableColumns = genColumns(non_empty_children)

    return tableColumns
  })

  return columns
}
